import {Component, OnDestroy, OnInit} from '@angular/core';
import SewingPatternInterface from '../../../models/sewing-pattern.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {PatternRepository} from '../../../repositories/pattern.repository';
import FabricInterface from '../../../models/fabric.interface';
import {FabricRepository} from '../../../repositories/fabric.repository';
import AnalyticsService from "../../../services/analytics.service";

@Component({
    selector: 'app-fabric-details',
    templateUrl: './fabric-details.page.html',
    styleUrls: ['./fabric-details.page.css'],
})
export class FabricDetailsPage implements OnInit, OnDestroy {

    fabric: FabricInterface;

    private fabricId$;

    constructor(private route: ActivatedRoute, private analytics: AnalyticsService, private fabricRepository: FabricRepository, private router: Router) {
    }

    ngOnDestroy(): void {
        this.fabricId$?.unsubscribe();
    }

    ngOnInit(): void {
        this.fabricId$ = this.route.params.subscribe(params => {
            this.fabric = this.fabricRepository.getByIdOrFirst(params.fabricId);
        });
    }

    get classes() {
        if (this.fabric.headerPath) {
            return '';
        }

        return 'fixed-height';
    }

    get imagePath() {
        if (this.fabric.headerPath) {
            console.log(this.fabric.headerPath);
            return this.fabric.headerPath;
        }

        return this.fabric.path;
    }

    get composition() {
        if (!this.fabric.details.composition) {
            return false;
        }
        return this.fabric.details.composition.replace('\n', '<br />');
    }

    get material() {
        return this.fabricRepository.materialById(this.fabric.material);
    }

    async buy(fabric: FabricInterface) {
        const shopUrl = fabric.details.shopUrl ?? fabric.shop.url;

        if (shopUrl) {
            this.analytics.logEvent({
                name: 'shop_fabric',
                params: {
                    url: shopUrl,
                    fabricName: fabric.name,
                    fabricId: fabric.id,
                }
            });

            window.open(shopUrl);
        }
    }
}
